import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { injectWorkflowId } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { WorkflowChangeRequestResponse } from "@idw-types/data/workflow-change-request";

export const createWorkflowChangeRequestRequest = async (
    workflowId: string
): Promise<{ data: WorkflowChangeRequestResponse, error: any }> => {
    const route = injectWorkflowId(
        apiRoutes.serviceConfiguration.workflowConfig.changeRequest.workflow.createChangeRequest,
        workflowId
    );
    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};